import { useMemo } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import { usePatientFileLockTakenOrReleasedSubscription as usePatientFileLockTakenOrReleasedSubscriptionType } from "@/modules/waiting-room/services/__generated__/usePatientFileLockTakenOrReleasedSubscription.graphql"

const patientFileLockTakenOrReleasedSubscription = graphql`
  subscription usePatientFileLockTakenOrReleasedSubscription {
    patientFileLockTakenOrReleased {
      lock {
        id
        lockedAt
        lockedBy
      }
      appointments {
        id
        patient {
          patientFileLock {
            lockedBy
            lockedAt
          }
        }
        ...appointmentStatusCell_appointment
      }
    }
  }
`

const usePatientFileLockTakenOrReleasedSubscription = () => {
  const createdSubscriptionConfig: GraphQLSubscriptionConfig<usePatientFileLockTakenOrReleasedSubscriptionType> =
    useMemo(
      () => ({
        variables: {},
        subscription: patientFileLockTakenOrReleasedSubscription,
        onError: (error: Error) => console.error(`An error occurred while subscribe to PatientFileLock:`, error),
        onCompleted: () => {
          console.log("server closed the PatientFileLock subscription ")
        },
      }),
      [],
    )

  return useSubscription<usePatientFileLockTakenOrReleasedSubscriptionType>(createdSubscriptionConfig)
}

export { usePatientFileLockTakenOrReleasedSubscription }
